import dayjs from 'dayjs';
import {parseTime} from '@/core/util/helper/datefns';

const resolveShiftBoundaries = (startTime, endTime) => {
  let start = parseTime(startTime, 'HH:mm');
  let end = parseTime(endTime, 'HH:mm');
  if (start > end) {
    end = dayjs(end).add(1, 'day').toDate();
  }

  return {start, end};
};

const resolvePermissionTime = (permissionTime, shiftStart) => {
  let permission = parseTime(permissionTime, 'HH:mm');
  if (permission <= shiftStart) {
    permission = dayjs(permission).add(1, 'day').toDate();
  }

  return permission;
};

export const createWorkShiftPermissionTimeRules = (
  getWorkShift,
  outsideWorkingHoursMessage,
) => {
  return [
    (value) => {
      const workShift = getWorkShift();
      if (!value || !workShift?.startTime || !workShift?.endTime) {
        return true;
      }

      const {start, end} = resolveShiftBoundaries(
        workShift.startTime,
        workShift.endTime,
      );
      const permission = resolvePermissionTime(value, start);

      if (permission <= start || permission > end) {
        return typeof outsideWorkingHoursMessage === 'function'
          ? outsideWorkingHoursMessage()
          : outsideWorkingHoursMessage;
      }

      return true;
    },
  ];
};
